import React from 'react';
import { useLocation } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export const CheckEmail = () => {
  const location = useLocation();
  const email = location.state?.email;

  return (
    <>
      <SEO title="Check Your Email | GHLWA" canonical="https://app.ghlwa.com/check-email" />
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'linear-gradient(160deg, #1e1b4b 0%, #3730a3 100%)' }}>
        <div className="bg-white rounded-2xl shadow-glass p-10 text-center max-w-md w-full mx-4">
          <img src="/ghlwa.png" alt="GHLWA" className="h-14 w-auto mx-auto mb-6" />
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-5">
            <FontAwesomeIcon icon={faEnvelopeOpenText} className="text-primary-600 text-3xl" />
          </div>
          <h2 className="text-2xl font-bold text-secondary-900 mb-3">Check your email</h2>
          <p className="text-secondary-500 mb-2">
            We sent a verification link to:
          </p>
          {email && <p className="font-semibold text-primary-600 mb-5">{email}</p>}
          <p className="text-secondary-400 text-sm mb-8">
            Click the link in the email to verify your account. Check your spam folder if you don't see it.
          </p>
          <a href="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors">
            <FontAwesomeIcon icon={faArrowLeft} className="text-xs" /> Back to login
          </a>
        </div>
      </div>
    </>
  );
};
